<template>
  <span class="user-dropdown-option">
    <Avatar :object="user" size="sm"></Avatar>
    <span class="user-dropdown-option__text">
      <span class="user-dropdown-option__name">{{ user.name }}</span>
      <span class="user-dropdown-option__email" v-if="user.email">{{ user.email }}</span>
    </span>
  </span>
</template>

<script>
import Avatar from '@/components/Avatar.vue';

// Option row of the add-user dropdowns: avatar, name and email
export default {
  name: 'UserDropdownOption',
  props: {
    user: {
      type: Object,
      required: true
    }
  },
  components: {
    Avatar
  }
}
</script>
